import {TFunction} from 'i18next';
import {SECTION_ID_FLOORS, constructFloorFilter} from '../filterConstructors';
import {SECTION_ID_RESOURCE_TYPE_FILTER, constructResourceTypeFilter} from '../filterConstructors/resourceTypeFilter';

export const constructHereAndNowExploreFilter = (floors: {id: string; name: string}[], t: TFunction) => {
  const floorFilters = constructFloorFilter(floors, t);
  const resourceTypeFilter = constructResourceTypeFilter(t);

  return {
    [SECTION_ID_FLOORS]: floorFilters,
    [SECTION_ID_RESOURCE_TYPE_FILTER]: resourceTypeFilter,
  };
};
